import { Injectable } from '@angular/core';
import { EmbeddedUiOverlayState } from '../embedded-ui-overlay';

@Injectable({ providedIn: 'root' })
export class ServiceUiOverlayService extends EmbeddedUiOverlayState {}
